import React from 'react'
import { Route, Switch } from 'react-router-dom'
import ListProjectTypes from './ListProjectTypes'
import ShowProjectTypePage from './ShowProjectTypePage'
import NewProjectTypePage from './NewProjectTypePage'
import EditProjectTypePage from './EditProjectTypePage'

// NOTE: ProjectTypeReports is linked directly on App since it's available to
//       regular users (not admin)
const ProjectTypes = ({ match }) => (
  <Switch>
    <Route exact path={match.url + '/'} component={ListProjectTypes} />
    <Route exact path={match.url + '/new'} component={NewProjectTypePage} />
    <Route path={match.url + '/:id/edit'} component={EditProjectTypePage} />
    <Route path={match.url + '/:id'} component={ShowProjectTypePage} />
  </Switch>
)

export default ProjectTypes



// WEBPACK FOOTER //
// ./src/components/ProjectTypes/ProjectTypes.jsx